import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

const Welcome = () => import(/* webpackChunkName: "view-Welcome" */ './views/Welcome.vue')
const Login = () => import(/* webpackChunkName: "component-WelcomeLogin" */ './components/Welcome/Login.vue')
const EmailVerification = () => import(/* webpackChunkName: "component-WelcomeEmailVerification" */ './components/Welcome/EmailVerification.vue')
const Activation = () => import(/* webpackChunkName: "component-WelcomeActivation" */ './components/Welcome/Activation.vue')

const Create = () => import(/* webpackChunkName: "component-OrderCreateCreate" */ './components/Order/Create/Create.vue')
const ListOrder = () => import(/* webpackChunkName: "component-OrderView" */ './components/Order/View/index.vue')
const Detail = () => import(/* webpackChunkName: "component-OrderViewOrderDetail" */ './components/Order/View/OrderDetail.vue')
const DocumentShipment = () => import(/* webpackChunkName: "component-OrderViewDocumentShipment" */ './components/Order/View/DocumentShipment.vue')
const StatusHistory = () => import(/* webpackChunkName: "component-OrderViewStatusHistory" */ './components/Order/View/StatusHistory.vue')
const TrackingShipment = () => import(/* webpackChunkName: "component-OrderViewTracking" */ './components/Order/View/Tracking.vue')

const DetailAccount = () => import(/* webpackChunkName: "component-AccountDetailAccount" */ './components/Account/DetailAccount.vue')
const ChangePassword = () => import(/* webpackChunkName: "component-AccountChangePassword" */ './components/Account/ChangePassword.vue')
const EditAccount = () => import(/* webpackChunkName: "component-AccountEditAccount" */ './components/Account/EditAccount.vue')

const UserAdmin = () => import(/* webpackChunkName: "view-UserAdmin" */ './views/UserAdmin.vue')
const UserAdminList = () => import(/* webpackChunkName: "component-UserAdminList" */ './components/UserAdmin/List.vue')
const UserAdminCreate = () => import(/* webpackChunkName: "component-UserAdminCreate." */ './components/UserAdmin/Create.vue')

const Home = () => import(/* webpackChunkName: "component-OrderHome" */ './components/Order/Home.vue')

const MainLayout = () => import(/* webpackChunkName: "view-MainLayout" */ './views/MainLayout.vue')

const About = () => import(/* webpackChunkName: "view-About" */ './views/About.vue')
const CallUs = () => import(/* webpackChunkName: "view-CallUs" */ './views/CallUs.vue')

const Pass = () => import(/* webpackChunkName: "view-Pass" */ './views/Pass.vue')
const Order = () => import(/* webpackChunkName: "view-Order" */ './views/Order.vue')
const Account = () => import(/* webpackChunkName: "view-Account" */ './views/Account.vue')

const Report = () => import(/* webpackChunkName: "view-Report" */ './views/Report.vue')
const ReportList = () => import(/* webpackChunkName: "component-ReportList" */ './components/Report/List.vue')
const ReportParameter = () => import(/* webpackChunkName: "component-ReportParameter" */ './components/Report/Parameter.vue')
const ReportAging = () => import(/* webpackChunkName: "component-ReportAging" */ './components/Report/ReportAging/index.vue')
const ReportCostEstimation = () => import(/* webpackChunkName: "component-ReportCostEstimation" */ './components/Report/ReportCostEstimation/index.vue')
const ReportOrderShipper = () => import(/* webpackChunkName: "component-ReportOrderShipper" */ './components/Report/ReportOrderShipper/index.vue')
const ReportBasp = () => import(/* webpackChunkName: "component-ReportBasp" */ './components/Report/ReportBASP/index.vue')
Vue.use(Router)

const shipperAllow = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    store.dispatch('user/fetchMyInfo', ['SHIPPER_SUPER_ADMIN'])
      .then(res => {
        return next()
      })
      .catch(err => {
        console.log('TCL: AuthGuard -> err', err)
        if (err === 'not allowed') {
          return next('/welcome/login')
        }
      })
      .finally(e => {
      })
  } else {
    next('/welcome/login')
  }
}

const shipperAdminAllow = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    store.dispatch('user/fetchMyInfo', ['SHIPPER_SUPER_ADMIN', 'SHIPPER_ADMIN'])
      .then(res => {
        return next()
      })
      .catch(err => {
        console.log('TCL: AuthGuard -> err', err)
        if (err === 'not allowed') {
          return next('/welcome/login')
        }
      })
      .finally(e => {
      })
  } else {
    next('/welcome/login')
  }
}

const shipperMonitorAllow = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    store.dispatch('user/fetchMyInfo', ['SHIPPER_SUPER_ADMIN', 'SHIPPER_ADMIN', 'SHIPPER_MONITORING'])
      .then(res => {
        return next()
      })
      .catch(err => {
        console.log('TCL: AuthGuard -> err', err)
        if (err === 'not allowed') {
          return next('/welcome/login')
        }
      })
      .finally(e => {
      })
  } else {
    next('/welcome/login')
  }
}

const loginPageGuard = (to, from, next) => {
  if (store.getters['auth/isLoggedIn']) {
    next('/main')
  } else {
    next()
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/main',
      component: MainLayout,
      title: 'Main',
      children: [
        {
          path: '',
          redirect: '/main/order/home'
        },
        {
          path: 'account',
          beforeEnter: shipperMonitorAllow,
          component: Account,
          title: 'Account',
          children: [
            {
              path: '',
              redirect: '/main/account/detail'
            },
            {
              path: 'detail',
              name: 'Detail-Account',
              component: DetailAccount,
              meta: {
                title: 'Detail Account'
              }
            },
            {
              path: 'change-password',
              name: 'Change-Password',
              component: ChangePassword,
              meta: {
                title: 'Change Password'
              }
            },
            {
              path: 'edit',
              name: 'Edit-Account',
              component: EditAccount,
              meta: {
                title: 'Edit Account'
              }
            },
          ]
        },
        {
          path: 'order',
          beforeEnter: shipperMonitorAllow,
          component: Order,
          title: 'Order',
          children: [
            {
              path: '',
              redirect: '/main/order/home'
            },
            {
              path: 'home',
              name: 'Home',
              beforeEnter: shipperAdminAllow,
              component: Home,
              meta: {
                title: 'Home',
              },
            },
            {
              path: 'create',
              name: 'Create',
              beforeEnter: shipperAdminAllow,
              component: Create,
              title: 'Create',
              props: true,
            },
            // {
            //   path: 'view',
            //   redirect: '/view/inprogress',
            // },
            {
              path: 'view/:tab',
              name: 'View-Order',
              beforeEnter: shipperMonitorAllow,
              component: ListOrder,
              title: 'View Order',
            },
            {
              path: 'detail/:id',
              name: 'Detail-Order',
              beforeEnter: shipperMonitorAllow,
              component: Detail,
              title: 'Detail',
            },
            {
              path: 'document/:id',
              name: 'Document',
              beforeEnter: shipperMonitorAllow,
              component: DocumentShipment,
              title: 'Surat Jalan',
              props: true
            },
            {
              path: 'status/:id',
              name: 'Status-History',
              beforeEnter: shipperMonitorAllow,
              component: StatusHistory,
              title: 'Detil Status',
              props: true,
            },
            {
              path: 'tracking/:id',
              name: 'Tracking-Shipment',
              beforeEnter: shipperMonitorAllow,
              component: TrackingShipment,
              title: 'Tracking Shipment',
              props: true,
            }
          ]
        },
        {
          path: 'user-admin',
          component: UserAdmin,
          children: [
            {
              path: '',
              redirect: '/main/user-admin/list',
            },
            {
              path: 'list',
              name: 'User Admin List',
              beforeEnter: shipperAdminAllow,
              component: UserAdminList,
              meta: {
                title: 'List User Admin'
              }
            },
            {
              path: 'create',
              name: 'User Admin Create',
              beforeEnter: shipperAllow,
              component: UserAdminCreate,
              meta: {
                title: 'Buat User Admin'
              }
            },
            {
              path: 'edit/:id',
              name: 'User Admin Edit',
              beforeEnter: shipperAllow,
              component: UserAdminCreate,
              meta: {
                title: 'Ubah User Admin'
              }
            }
          ]
        },
        {
          path: 'report',
          component: Report,
          children: [
            {
              path: 'list',
              name: 'Report List',
              beforeEnter: shipperAdminAllow,
              component: ReportList,
              meta: {
                title: 'Daftar Laporan'
              }
            },
            {
              path: ':id',
              name: 'Report Parameter',
              beforeEnter: shipperAdminAllow,
              component: ReportParameter,
              meta: {
                title: 'Parameter Laporan'
              },
            },
            {
              path: '1/list',
              name: 'Report Order Shipper',
              beforeEnter: shipperAdminAllow,
              component: ReportOrderShipper,
              meta: {
                title: 'Laporan Pesanan Shipper Per Status'
              }
            },
            {
              path: '2/list',
              name: 'Report Cost Estimation',
              beforeEnter: shipperAdminAllow,
              component: ReportCostEstimation,
              meta: {
                title: 'Laporan Estimasi Biasa'
              }
            },
            {
              path: '3/list',
              name: 'Report Basp',
              beforeEnter: shipperAdminAllow,
              component: ReportBasp,
              meta: {
                title: 'Detil Laporan Basp',
              }
            },
            {
              path: '4/list',
              name: 'Report Aging',
              beforeEnter: shipperAdminAllow,
              component: ReportAging,
              meta: {
                title: 'Laporan Aging'
              }
            },
          ]
        },
        {
          path: 'pass',
          name: 'pass',
          beforeEnter: shipperMonitorAllow,
          component: Pass,
        },
        {
          path: 'about',
          name: 'About',
          beforeEnter: shipperMonitorAllow,
          component: About,
        },
        {
          path: 'call',
          name: 'Call Us',
          beforeEnter: shipperMonitorAllow,
          component: CallUs,
        },
      ]
    },
    {
      path: '/welcome',
      component: Welcome,
      beforeEnter: loginPageGuard,
      children: [
        {
          path: '',
          redirect: '/welcome/login'
        },
        {
          path: 'login',
          name: 'login',
          component: Login,
          meta: {
            title: 'Masuk'
          }
        },
        {
          path: 'verification',
          name: 'email-verification',
          component: EmailVerification,
          meta: {
            title: 'Verifikasi Email'
          }
        },
        {
          path: 'activation',
          name: 'activation',
          component: Activation,
          meta: {
            title: 'Aktifasi Akun'
          }
        }
      ]
    },
    {
      path: '*',
      beforeEnter: shipperMonitorAllow,
      redirect: '/main/order/view/inprogress'
    }
  ]
})

router.beforeResolve((to, from, next) => {
  document.title = to.meta.title || 'Shipper Admin Dashboard'
  next()
})

export default router
